<template>
  <div class="over_view">
    <div class="part part1">
      <div class="title">剩余科目卡</div>
      <div class="surplus_card">
        <div class="card_modular">
          <div class="modu_top">
            <span class="modu_title">
              月卡
              <img src="../../src/assets/img/未标题-3-03.png" alt />
            </span>
            <span class="number">22</span>
          </div>
          <div class="modu_bottom">
            <span class="tips">剩余卡数：不多</span>
            <span class="buy_btn">请尽快购买</span>
          </div>
        </div>
        <div class="card_modular">
          <div class="modu_top">
            <span class="modu_title">
              季卡
              <img src="../../src/assets/img/未标题-3-03.png" alt />
            </span>
            <span class="number">22</span>
          </div>
          <div class="modu_bottom">
            <span
              class="tips"
              :style="{backgroundColor: b < 10 ? '#FF3636' : b<20 ? '#F1C205' : b < 30 ? '#F1C205': '#6CC645' }"
            >剩余卡数：充足</span>
            <span class="buy_btn">请尽快购买</span>
          </div>
        </div>
        <div class="card_modular">
          <div class="modu_top">
            <span class="modu_title">
              半年卡
              <img src="../../src/assets/img/未标题-3-03.png" alt />
            </span>
            <span class="number">105</span>
          </div>
          <div class="modu_bottom">
            <span
              class="tips"
              :style="{backgroundColor: a < 10 ? '#FF3636' : a<20 ? '#F1C205' : a < 30 ? '#F1C205': '#6CC645' }"
            >剩余卡数：正常</span>
            <span class="buy_btn">请尽快购买</span>
          </div>
        </div>
        <div class="card_modular">
          <div class="modu_top">
            <span class="modu_title">
              年卡
              <img src="../../src/assets/img/未标题-3-03.png" alt />
            </span>
            <span class="number">22</span>
          </div>
          <div class="modu_bottom">
            <span class="tips">剩余卡数：不多</span>
            <span class="buy_btn">请尽快购买</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part part2">
      <div class="title">待办事项</div>
      <div class="todo_list todo_two">
        <div class="todo_content todo_one">
          <div class="left">
            <!-- <i class="iconfont iconweibiaoti-3-03"></i> -->
            <img class="icon" src="../../src/assets/img/未标题-3-10.png" alt />
          </div>
          <div class="right">
            <span class="todo_title">科目开通待审核</span>
            <span class="number">22</span>
          </div>
        </div>
        <div class="todo_content todo_two">
          <div class="left">
            <img class="icon" src="../../src/assets/img/未标题-3-03.png" alt />
          </div>
          <div class="right">
            <span class="todo_title">赠卡进度查询</span>
            <span class="number">22</span>
          </div>
        </div>
        <div class="todo_content todo_there">
          <div class="left">
            <img class="icon" src="../../src/assets/img/未标题-3-04.png" alt />
          </div>
          <div class="right">
            <span class="todo_title">未读公告信息</span>
            <span class="number">22</span>
          </div>
        </div>
        <div class="todo_content todo_four">
          <div class="left">
            <img class="icon" src="../../src/assets/img/未标题-3-12.png" alt />
          </div>
          <div class="right">
            <span class="todo_title">即将到期学生</span>
            <span class="number">22</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part part3">
      <div class="title">店铺运营情况概览</div>
      <div class="shop_view">
        <div class="shop_situation">
          <div class="left">
            <div class="shop_title">当月新增学生</div>
          </div>
          <div class="right">
            <div class="nav">
              <div class="nav_left">
                <img class="icon" src="../../src/assets/img/未标题-3-05.png" alt />
              </div>
              <div class="nav_right">
                <div class="nav_title">体验学生</div>
                <div>
                  <span class="number">212</span>
                  <img class="icon" src="../../src/assets/img/未标题-3-19.png" alt />
                </div>
              </div>
            </div>
            <div class="nav">
              <div class="nav_left">
                <img class="icon" src="../../src/assets/img/未标题-3-06.png" alt />
              </div>
              <div class="nav_right">
                <div class="nav_title">试用学生</div>
                <div>
                  <span class="number">212</span>
                  <img class="icon" src="../../src/assets/img/未标题-3-19.png" alt />
                </div>
              </div>
            </div>
            <div class="nav">
              <div class="nav_left">
                <img class="icon" src="../../src/assets/img/未标题-3-05.png" alt />
              </div>
              <div class="nav_right">
                <div class="nav_title">在学学生</div>
                <div>
                  <span class="number">212</span>
                  <img class="icon" src="../../src/assets/img/未标题-3-02.png" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="shop_situation">
          <div class="left">
            <div class="shop_title">当前学生</div>
          </div>
          <div class="right">
            <div class="nav">
              <div class="nav_left">
                <img class="icon" src="../../src/assets/img/未标题-3-05.png" alt />
              </div>
              <div class="nav_right">
                <div class="nav_title">体验学生</div>
                <div>
                  <span class="number">212</span>
                  <img class="icon" src="../../src/assets/img/未标题-3-02.png" alt />
                </div>
              </div>
            </div>
            <div class="nav">
              <div class="nav_left">
                <img class="icon" src="../../src/assets/img/未标题-3-06.png" alt />
              </div>
              <div class="nav_right">
                <div class="nav_title">试用学生</div>
                <div>
                  <span class="number">212</span>
                  <img class="icon" src="../../src/assets/img/未标题-3-19.png" alt />
                </div>
              </div>
            </div>
            <div class="nav">
              <div class="nav_left">
                <img class="icon" src="../../src/assets/img/未标题-3-07.png" alt />
              </div>
              <div class="nav_right">
                <div class="nav_title">在学学生</div>
                <div>
                  <span class="number">212</span>
                  <img class="icon" src="../../src/assets/img/未标题-3-19.png" alt />
                </div>
              </div>
            </div>
            <div class="nav">
              <div class="nav_left">
                <img class="icon" src="../../src/assets/img/未标题-3-08.png" alt />
              </div>
              <div class="nav_right">
                <div class="nav_title">到期待续费学生</div>
                <div>
                  <span class="number">212</span>
                  <img class="icon" src="../../src/assets/img/未标题-3-19.png" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="shop_situation">
          <div class="left">
            <div class="shop_title">累计新增学生</div>
          </div>
          <div class="right">
            <div class="nav">
              <div class="nav_left">
                <img class="icon" src="../../src/assets/img/未标题-3-05.png" alt />
              </div>
              <div class="nav_right">
                <div class="nav_title">体验学生</div>
                <div>
                  <span class="number">212</span>
                  <img class="icon" src="../../src/assets/img/未标题-3-19.png" alt />
                </div>
              </div>
            </div>
            <div class="nav">
              <div class="nav_left">
                <img class="icon" src="../../src/assets/img/未标题-3-09.png" alt />
              </div>
              <div class="nav_right">
                <div class="nav_title">购买学生</div>
                <div>
                  <span class="number">212</span>
                  <img class="icon" src="../../src/assets/img/未标题-3-19.png" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part part4">
      <div class="title">销售完成情况概览</div>
      <div class="todo_list todo_two">
        <div class="todo_content todo_one">
          <div class="left">
            <img class="icon" src="../../src/assets/img/未标题-3-16.png" alt />
          </div>
          <div class="right">
            <span class="todo_title">当月新增学生</span>
            <span class="number">22</span>
          </div>
        </div>
        <div class="todo_content todo_two">
          <div class="left">
            <img class="icon" src="../../src/assets/img/未标题-3-07.png" alt />
          </div>
          <div class="right">
            <span class="todo_title">当前学生</span>
            <span class="number">22</span>
          </div>
        </div>
        <div class="todo_content todo_there">
          <div class="left">
            <img class="icon" src="../../src/assets/img/未标题-3-01.png" alt />
          </div>
          <div class="right">
            <span class="todo_title">累计新增学生</span>
            <span class="number">22</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part5">
      <div class="poster_left">
        <div class="title">二维码、海报下载</div>
        <div class="content">
          <div class="qrcode" @click="handleShow()">下载招生二维码</div>
          <div class="download">下载招生海报</div>
        </div>
      </div>
      <div class="poster_right">
        <div class="title">海报模板</div>
        <div class="content">
          <div class="content_item">
            <span class="select_title">海报模板：</span>
            <el-select popper-class="poster_select" v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="part6">
      <div class="subject_left">
        <div class="title">科目卡累计销量</div>
        <div class="content">
          <div id="sumChart" :style="{ width: '100%', height: '290px' }"></div>
        </div>
      </div>
      <div class="subject_right">
        <div class="title">科目累计购买人次</div>
        <div class="content">
          <div class="content_left">
             <div id="primaryChart" :style="{ width: '100%', height: '290px' }"></div>
          </div>
          <span class="line"></span>
          <div class="content_right">
             <div id="juniorMiddleChart" :style="{ width: '100%', height: '290px' }"></div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="下载海报"
      class="poster_download_alert"
      :visible="isShowAlert"
      width="640px"
      top="36vh"
      @close="closeDialog"
      :show-close="true"
      size="tiny">
      <div class="dialog_content">
        <div class="left">
          <div class="fun_one">
            <div class="fun_left">
              <i class="iconfont">&#xe640;</i>
            </div>
            <div class="fun_right">
              <span class="title">方法一</span>
              <div class="tips">打开微信扫一扫下面二维码，保存图片到手机上</div>
              <div class="QrCode">
                <img src alt />
              </div>
            </div>
          </div>
          <div class="fun_two">
            <div class="fun_left">
              <i class="iconfont">&#xe640;</i>
            </div>
            <div class="fun_right">
              <span class="title">方法二</span>
              <div class="tips">直接下载到电脑上</div>
              <div class="btn">下载到电脑</div>
            </div>
          </div>
        </div>
        <div class="right">
          <img src alt />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      a: 15,
      b: 35,
      options: [
        {
          value: 1,
          label: "黄金糕"
        },
        {
          value: 2,
          label: "双皮奶"
        },
        {
          value: 3,
          label: "蚵仔煎"
        },
        {
          value: 4,
          label: "龙须面"
        },
        {
          value: 5,
          label: "北京烤鸭"
        }
      ],
      subjectSumStr: ['月卡','季卡','半年卡','年卡'],
      subjectSumData: [53456,92345,23456,63456],

      primaryStr: ['语文','数学','英语','科学'],
      primaryData: [53456,92345,23456,63456],

      juniorMiddleStr: ['语文','数学','英语','科学','历史','地理','生物'],
      juniorMiddleData: [53456,92345,23456,63456,92345,23456,63456],
      value: "",
      isShowAlert: false
    };
  },
  mounted() {
    // 科目累计销量
    this.drawLine( 'sumChart', this.subjectSumStr, this.subjectSumData);
    // 小学购买人数
    this.drawLine( 'primaryChart', this.primaryStr, this.primaryData);
    // 初中购买人数
    this.drawLine( 'juniorMiddleChart', this.juniorMiddleStr, this.juniorMiddleData);
  },
  methods: {
    /**
     * 绘制柱形图
     * @param idName dom的id名
     * @param dataStr X轴显示文案
     * @param dataY Y轴数据
     */
    drawLine(idName, dataStr, dataY) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById(idName));
      myChart.setOption({
        color: ['#0D56F1'],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "0%",
          right: "13%",
          bottom: "15%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: dataStr,
            axisTick: {
              show: false,
              alignWithLabel: false
            },
            color: '#333333',
            axisLine: {
              show: false
            },
            splitLine: {show: false},
          }
        ],
        yAxis: [
          {
            type: "value",
            show: false,
            position: 'left'
          }
        ],
        series: [
          {
            name: "",
            type: "bar",
            barWidth: "60%",
            data: dataY,
            label: {
                show: true,
                position: 'bottom',
                lineHeight: 46,
                color: '#666666',
                fontSize: '13px',
            },
          }
        ]
      });
    },

    handleShow() {
      this.isShowAlert = true;
    },

    closeDialog() {
      this.isShowAlert = false;
    },

    posterDown() {}
  }
};
</script>

<style lang="less" scoped>
.over_view {
  width: 1216px;
  background-color: #eceff3;
  margin: 0 auto;
  min-height: 660px;
  padding: 12px;
  padding-bottom: 325px;
  .part {
    background-color: #fff;
    padding: 0 20px;
    margin-bottom: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    .title {
      height: 54px;
      font-size: 16px;
      line-height: 72px;
      font-weight: 600;
      text-align: left;
      border-bottom: 1px solid #eeeeee;
    }
    .icon {
      width: 25px;
      height: 25px;
    }
  }
  .part1 {
    .surplus_card {
      padding: 24px 0 43px 0;
      display: flex;
      flex-direction: row;
      .card_modular {
        height: 135px;
        width: 270px;
        padding: 10px;
        background-color: #0d56f1;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        margin-right: 17px;
        color: #fff;
        &:last-of-type {
          margin-right: 0;
        }
        .modu_top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid rgba(255, 255, 255, 0.4);

          .modu_title {
            font-size: 16px;
            line-height: 22px;
            position: relative;
            img {
              position: absolute;
              bottom: 0;
              width: 25px;
              height: 22px;
            }
          }
          .number {
            font-size: 34px;
            line-height: 48px;
          }
        }
        .modu_bottom {
          padding-top: 39px;
          display: flex;
          justify-content: space-between;
          .tips,
          .buy_btn {
            font-size: 14px;
            height: 32px;
            line-height: 32px;
            border-radius: 16px;
            padding: 0 12px;
          }
          .tips {
            background-color: #ff3636;
          }
          .buy_btn {
            border: 1px solid #fff;
          }
        }
      }
    }
  }
  .part2,
  .part4 {
    .todo_list {
      display: flex;
      flex-direction: row;
      height: 160px;
      .todo_content {
        padding: 42px 0 42px 72px;
        // width: 304px;
        color: #333;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-items: center;
        .left {
          text-align: top;
          margin-right: 8px;
          i {
            color: #0d56f1;
            line-height: 25px;
            font-size: 20px;
          }
        }
        .right {
          display: flex;
          flex-direction: column;
          .todo_title {
            font-size: 16px;
            line-height: 22px;
          }
          .number {
            font-size: 34px;
            line-height: 48px;
            font-weight: 600;
          }
        }
      }
    }
  }
  .part3 {
    .shop_view {
      display: flex;
      flex-direction: column;

      .shop_situation {
        width: 100%;
        display: flex;
        flex-direction: row;
        padding: 16px 0;
        border-bottom: 1px solid #eeeeee;
        .left {
          height: 90px;
          width: 140px;
          border-right: 1px solid #eeeeee;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .shop_title {
            text-align: left;
            color: #333;
            font-size: 16px;
          }
        }
        .right {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .nav {
            display: flex;
            flex-direction: row;
            padding-left: 40px;
            min-width: 216px;
            .nav_left {
              margin-right: 8px;
              i {
                color: red;
                font-size: 24px;
              }
            }
            .nav_right {
              .nav_title {
                font-size: 14px;
                line-height: 20px;
                color: #333333;
              }
              div {
                .number {
                  font-size: 34px;
                  line-height: 48px;
                  color: #333;
                  font-weight: 600;
                }
                i {
                  color: green;
                  font-size: 24px;
                  margin-left: 8px;
                }
              }
            }
          }
        }
      }
    }
  }
  .part5 {
    display: flex;
    flex-direction: row;
    background-color: #eceff3;
    justify-content: space-between;
    .poster_left,
    .poster_right {
      width: 49%;
      background-color: #fff;
      padding: 0 20px;
      .title {
        height: 54px;
        font-size: 16px;
        line-height: 72px;
        font-weight: 600;
        text-align: left;
        border-bottom: 1px solid #eeeeee;
      }
      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .qrcode,
        .download {
          height: 32px;
          font-size: 14px;
          font-weight: 500;
          line-height: 32px;
          text-align: center;
          border-radius: 4px;
          width: 319px;
          background-color: #0d56f1;
          color: #fff;
          cursor: pointer;
        }
        .qrcode {
          margin-top: 56px;
        }
        .download {
          margin-top: 24px;
          margin-bottom: 56px;
        }
      }
    }
    .poster_right {
      margin-left: 12px;
      .content {
        .content_item {
          margin-top: 56px;
          .select_title {
            font-size: 14px;
            line-height: 22px;
            color: #333;
          }
          .el-select {
            width: 256px;
            height: 32px;

            /deep/.el-input__inner {
              width: 256px;
              height: 32px;
              line-height: 32px;
              border: 1px solid #0d56f1;
            }
            /deep/.el-select-dropdown__list {
              display: flex;
              flex-direction: column;
            }
            /deep/.el-input__suffix {
              /deep/.el-input__icon {
                line-height: 32px;
              }
            }
          }
        }
      }
    }
  }
  .part6 {
    display: flex;
    flex-direction: row;
    background-color: #eceff3;
    justify-content: space-between;
    margin-top: 12px;
    .subject_left,
    .subject_right {
      background-color: #fff;
      padding: 0 20px;
      .title {
        height: 54px;
        font-size: 16px;
        line-height: 72px;
        font-weight: 600;
        text-align: left;
        border-bottom: 1px solid #eeeeee;
      }
      .content {
        // display: flex;
        // flex-direction: column;
        // align-items: center;
      }
    }
    .subject_left {
      width: 32%;
    }
    .subject_right {
      width: 66%;
      margin-left: 12px;
      .content {
        display: flex;
        flex-direction: row;
        .line {
          border-right: 1px solid #EEEEEE;
          display: inline-block;
          height: 302px; 
          margin: 12px;
        }
        .content_left {
          width: 319px;
        }
        .content_right {
          width: 484px;
        }
      }
    }
  }
  .poster_download_alert {
    /deep/.el-dialog__header {
      border: 1px solid #eeeeee;
    }
    .dialog_content {
      display: flex;
      flex-direction: row;
      .left {
        width: 368px;
        .fun_one,
        .fun_two {
          display: flex;
          flex-direction: row;
          .fun_left {
            margin-right: 8px;
            i {
              font-size: 24px;
              color: aqua;
            }
          }
          .fun_right {
            min-width: 295px;
            .title {
              font-size: 16px;
              line-height: 22px;
              font-weight: 500;
            }
            .tips {
              font-weight: 400;
              color: #666;
              font-size: 14px;
              line-height: 22px;
              margin-top: 8px;
            }
            .QrCode {
              margin: 24px auto;
              width: 114px;
              height: 114px;
              border: 1px solid red;
            }
            .btn {
              border-radius: 4px;
              height: 32px;
              width: 160px;
              color: #fff;
              margin: 24px auto;
              line-height: 32px;
              text-align: center;
              background-color: #0d56f1;
            }
          }
        }
      }
      .right {
        width: 192px;
        height: 336px;
        border: 1px solid red;
      }
    }
  }
}
</style>